import springApi from '../../services/springApi'

export const getTickets = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/tickets', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeTicket = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/tickets', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateTicket = (id, data) => (
	new Promise((resolve, reject) => {
		springApi()
			.put(`/tickets/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteTicket = id => (
	new Promise((resolve, reject) => {
		springApi()
			.delete(`/tickets/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)